import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout';
import ContentHeader from '../layout/ContentHeader';
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import { Link, useParams } from 'react-router-dom';
import httpClient from '../../../http/HttpRequest';
import { COMPANY_DETAILS, GET_EXPENSE_DETAILS } from '../../../data/url';
import InvoiceHeader from '../layout/invoice/InvoiceHeader';
import InvoiceAddress from '../layout/invoice/InvoiceAddress';
import Helper from '../../../helper/Helper';
import { generatePDF } from '../../pdf/GeneratePDF';

export default function ViewExpense() {
     const [expense, setExpense] = useState({});
     const [company, setCompanyDetails] = useState({});
     const [customer, setCustomer] = useState({});
     const { t } = useTranslation();
     const { id } = useParams();
     const [sameState, setSameState] = useState(0);
     const thStyle = { lineHeight: "1", verticalAlign: "center" };

     const componentRef = React.useRef();

     const handlePrint = useReactToPrint({
          content: () => componentRef.current,
     });   

     useEffect(() => {
          if (customer && customer.state === company.state) {
               setSameState(1);
          } else {
               setSameState(0);
          }
     }, [customer, company]);

     const getExpenseData = async () => {
          const res = await httpClient.post(GET_EXPENSE_DETAILS, { id: id });
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    let data = result.data;
                    let details = data.expense_details;
                    details['payment_date'] = details['date'];
                    details['reference'] = details['ref_number'];
                    details['mode'] = details['payment_mode'];
                    details['amount'] = details['total'];
                    setExpense(details);
                    setCustomer(data.customer);
               }
          }
     }

     const getCompanyDetails = async () => {
          const res = await httpClient.post(COMPANY_DETAILS, {});
          if (res.requestStatus === 'OK') {
               const result = res.result;
               if (result.status === 1) {
                    setCompanyDetails(result.data);
               }
          };
     }

     useEffect(() => {
          getCompanyDetails();
          getExpenseData();
     }, []);

     const makePdf = () => {
          let filename = `${expense.number}-EXPENSE`;
          generatePDF(filename); 
     };
     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="view_expense" subTitle="expense" subTitleLink="root/expense" />
                    <div className="card col-md-11 m-auto" id="expense">
                         <div className="card-body" id="print_section" ref={componentRef}>
                              <InvoiceHeader title="payment_receipt" number={`${expense.prefix} - ${expense.number}`} />
                              <InvoiceAddress title="payment_receipt" customer={customer} company={company} order={expense} />

                              <table className="text-center table table-striped table-hover">
                                   <thead className='bg-primary text-white '>
                                        <tr className='text-center' >
                                             <th>{t('item_name')}</th>
                                             <th>{t('unit')}</th>
                                             <th>{t('qty')}</th>
                                             <th>{t('price')}</th>
                                             {sameState === 1 ? <><th>{t('cgst')}</th><th>{t('sgst')}</th></> : <th>{t('igst')}</th>}
                                        </tr>
                                   </thead>
                                   <tbody>
                                        <tr>
                                             <td>{expense.item_name}</td>
                                             <td>{expense.name}</td>
                                             <td>{expense.quantity}</td>
                                             <td>{Helper.formatNumber(expense.price)}</td>
                                             {sameState === 1 ? <>
                                                  <td>{Helper.formatNumber(expense.cgst)} %</td>
                                                  <td>{Helper.formatNumber(expense.sgst)} %</td>
                                             </> :
                                                  <td>{Helper.formatNumber(expense.igst)} %</td>
                                             }
                                        </tr>
                                   </tbody>
                              </table>
                              <div className='row mt-3'>
                                   <div className='col-md-8'>
                                        {t('notes')} : {expense.terms_conditions}
                                   </div>
                                   <div className='col-md-4'>
                                        <table className='table table-sm table-borderless'>
                                             <tbody>
                                                  <tr>
                                                       <td style={thStyle}><strong>{t('subtotol')}</strong></td>
                                                       <td style={thStyle} className='text-right'><strong>{Helper.formatNumber(expense.taxableAmount)}</strong></td>
                                                  </tr>
                                                  {sameState === 1 &&
                                                       <>
                                                            <tr>
                                                                 <td style={thStyle}><strong>{t('cgst')}</strong></td>
                                                                 <td style={thStyle} className='text-right'><strong>{Helper.formatNumber(expense.taxAmount / 2)}</strong></td>
                                                            </tr>
                                                            <tr>
                                                                 <td style={thStyle}><strong>{t('sgst')}</strong></td>
                                                                 <td style={thStyle} className='text-right'><strong>{Helper.formatNumber(expense.taxAmount / 2)}</strong></td>
                                                            </tr>
                                                       </>
                                                  }
                                                  {sameState === 0 &&
                                                       <tr>
                                                            <td style={thStyle}><strong>{t('igst')}</strong></td>
                                                            <td style={thStyle} className='text-right'><strong>{expense.taxAmount}</strong></td>
                                                       </tr>
                                                  }
                                                  {expense.rounded_off !== 0 &&
                                                       <tr>
                                                            <td style={thStyle}><strong>{t('rounded_off')}</strong></td>
                                                            <td style={thStyle} className='text-right'><strong>{Helper.formatNumber(expense.rounded_off)}</strong></td>
                                                       </tr>
                                                  }
                                                  <tr>
                                                       <td style={thStyle} className='text-success'><strong>{t('Total')}</strong></td>
                                                       <td style={thStyle} className='text-right text-success'><strong>{Helper.formatNumber(expense.total)}</strong></td>
                                                  </tr>
                                             </tbody>
                                        </table>
                                   </div>
                              </div>
                         </div>
                         <div className='text-center'>
                              <Link to={`/root/expense/edit/${id}`} className='btn btn-sm btn-primary m-1'>{t('edit')}</Link>
                              <button className="btn btn-sm btn-danger m-1" onClick={makePdf}>{t('pdf')}</button>
                              <button className="btn btn-sm btn-info m-1" onClick={handlePrint}>{t('print')}</button>
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
